import { render, staticRenderFns } from "./TokenExpiredModal.vue?vue&type=template&id=4bd02108"
import script from "./TokenExpiredModal.vue?vue&type=script&lang=js"
export * from "./TokenExpiredModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports